import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'graphql_get_ranked_badges';

// Example set of params for the query
/*
{
    "listingId": "321.887611.1435551"
}
 */

const rankedBadgesQuery = `
    query rankedBadges($listingId : String!, $startDate : String, $endDate : String) {
        rankedBadges(listingTriad : $listingId, startDate : $startDate, endDate : $endDate, rankingStrategy: PDP) {
            id
            name
        }
    }
`;

async function rankedBadgesGraphQl({listingId, startDate, endDate, locale}) {
    return await graphqlQuery(
        OPERATION_NAME,
        rankedBadgesQuery,
        {listingId},
        {startDate},
        {endDate},
        locale
    );
}

export default rankedBadgesGraphQl;
export {OPERATION_NAME, rankedBadgesGraphQl, rankedBadgesQuery};
